module.exports = __webpack_public_path__ + "static/media/Akkurat-Light.a7ead98d.woff";